import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import { FormApi } from 'final-form';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IOwnerTrustFormProps {
    handleOnSubmit: (formValues: OwnerTrust) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

interface IOwnerTrustState {
    form: FormApi;
}

class OwnerTrustForm extends React.Component<IOwnerTrustFormProps, IOwnerTrustState> {
    constructor(props: IOwnerTrustFormProps) {
        super(props);
        this.state = { form: undefined };
    }

    componentWillUnmount(): void {
        this.setState({ form: undefined });
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'ownerTrust.trustName')) {
            _.set(errors, 'ownerTrust.trustName', 'Required');
        }
        if (!_.get(values, 'ownerTrust.contactPersonFirstName')) {
            _.set(errors, 'ownerTrust.contactPersonFirstName', 'Required');
        }
        if (!_.get(values, 'ownerTrust.contactPersonLastName')) {
            _.set(errors, 'ownerTrust.contactPersonLastName', 'Required');
        }
    };

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerTrust(formValues.ownerTrust);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();
        const ownerTrust = this.props.ownerData.ownerDetails as OwnerTrust;
        console.log('correct data', ownerTrust);

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>Trust Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    initialValues={{ ownerTrust: ownerTrust }}
                    onFormCreated={(form) => {
                        this.setState({ form: form });
                    }}
                    hasFieldArray={true}
                    style={{padding: '3rem', paddingTop: '3rem'}}
                >
                    <div>
                        <FormTextBox 
                            name="ownerTrust.trustName" 
                            label="Trust Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="ownerTrust.trustees" 
                            label="Trustees" 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="ownerTrust.ssnTaxId" 
                            label="Tax Id" 
                            className="lh-third-width"
                            style={{marginLeft: '.5rem'}}  
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Contact Person</legend>
                    </fieldset>
                    <div>
                        <FormSelect 
                            name="ownerTrust.contactPersonPrefix" 
                            label="Prefix" 
                            items={Prefixes} 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="ownerTrust.contactPersonSuffix" 
                            label="Suffix" 
                            items={Suffixes} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="ownerTrust.email" 
                            label="Email" 
                            className="lh-third-width"
                            style={{marginLeft: '.5rem'}}  
                        />
                    </div>
                    <div>
                        <FormTextBox 
                            name="ownerTrust.contactPersonFirstName" 
                            label="First Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="ownerTrust.contactPersonMiddleName" 
                            label="Middle Name" 
                            className="lh-third-width"
                        />
                        <FormTextBox 
                            name="ownerTrust.contactPersonLastName" 
                            label="Last Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                            style={{marginLeft: '.5rem'}} 
                        />
                        
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Address</legend>
                    </fieldset>
                        <FormTextBox 
                            name="ownerTrust.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-full-width"
                        />
                        <FormTextBox 
                            name="ownerTrust.address.addressLine2" 
                            label="Address Line 2" 
                            className="lh-full-width"
                        />
                    <div>
                        <FormTextBox 
                            name="ownerTrust.address.city" 
                            label="City" 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="ownerTrust.address.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="ownerTrust.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <div>
                        <FormCheckbox   
                            name="ownerTrust.isClientAcreage" 
                            label="This is the Client" 
                        />
                    </div>
                    <div style={{marginLeft: '.5rem'}}>
                        <MultiplePhoneNumber 
                            baseFieldName="ownerTrust" 
                            form={this.state.form} 
                            phoneNumberTypes={this.props.phoneNumberTypes} 
                        />
                    </div>
                    <div className="button-row">
                        <Button 
                            text="Save" 
                            type="submit" 
                            intent="primary" 
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                </Form>
            </div>
        );
    }
}

export default OwnerTrustForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerTrustForm.tsx